<template>
  <div class="conteudo-sistema">
    <div v-if="!exibeForm">
      <div class="fl-cabecalho" style="backgroud-color: red">
        <div class="row animated slideInDown">
          <div class="col-12 form-group">
            <h4 class="animated slideInDown">
              <fa-icon icon="ticket-alt" />Tickets
              <button
                @click="clickCadastrar"
                class="btn btn-sm btn-outline-primary float-right"
              >
                <fa-icon icon="plus" />
                <span v-if="!_isMobile">Cadastrar</span>
              </button>
            </h4>
          </div>
        </div>

        <div class="row">
          <div class="col-md-12">
            <div class="block-flat" style="margin: 3px 0px 20px; padding: 0px; ">
              <div
                id="mostra-filtros"
                class="muda-filtro"
                @click="alterarFiltros(false)"
                v-if="exibirFiltro"
              >
                <h4>
                  <fa-icon icon="search" /> Mostrar Filtros
                </h4>
              </div>
              <div id="filtros" v-if="!exibirFiltro">
                <div class="row" style="padding-top:10px;padding-left:10px;padding-right:10px">
                  <div class="col-lg-4 form-group col-md-10">
                    <fa-icon icon="key" />
                    <label class="col-form-label col-form-label-sm font-weight-bold">Código:</label>
                    <input
                      v-model="codigo"
                      class="form-control form-control-sm"
                      name="Codigo"
                      placeholder="Informe o código"
                    />
                  </div>
                  <div class="col-lg-4 form-group col-md-10">
                    <fa-icon icon="user" />
                    <label class="col-form-label col-form-label-sm font-weight-bold">Cliente:</label>
                    <!-- <input
                      v-on:keyup="onKeyUp"
                      class="form-control form-control-sm"
                      v-validate="''"
                      name="Cliente"
                      placeholder="Informe o nome do cliente"
                      :class="{'is-invalid' : errors.has('Cliente')}"
                    /> -->
                    <select
                      name="cliente"
                      v-model="cliente"
                      @change="carregaDados()"
                      v-validate="''"
                      class="form-control form-control-sm"
                    >
                      <option value="">Todos</option>
                      <option
                        v-for="(clientesOption, clienteIndex) of clientesOptions"
                        :value="clientesOption.nome"
                        :key="clienteIndex"
                        :selected="clientesOption.nome === cliente">
                        {{clientesOption.nome}}
                      </option>
                    </select>
                  </div>

                  <div class="col-lg-4 form-group col-md-10">
                    <fa-icon icon="cubes" />
                    <label class="col-form-label col-form-label-sm font-weight-bold">Prioridade:</label>
                    <select
                      @change="carregaDados()"
                      name="Prioridade"
                      v-model="prioridade"
                      :disabled="!_getPrivilegio(36)"
                      :class="{'is-invalid' : errors.has('Prioridade')}"
                      class="form-control form-control-sm"
                    >
                      <option value="">Todas</option>
                      <option v-for="prioridadesOption of prioridadesOptions"
                        :key="prioridadesOption.id"
                        :value="prioridadesOption.id"
                        :selected="prioridadesOption.value === prioridade">
                        {{prioridadesOption.value}}
                      </option>
                    </select>
                  </div>

                  <div class="col-lg-4 form-group col-md-10">
                    <fa-icon icon="users" />
                    <label class="col-form-label col-form-label-sm font-weight-bold">Responsável:</label>
                    <!-- <input
                      v-on:keyup="onKeyUp"
                      class="form-control form-control-sm"
                      v-validate="''"
                      name="Responsável"
                      placeholder="Informe o responsável"
                      :class="{'is-invalid' : errors.has('Responsável')}"
                    /> -->
                    <select
                      @change="carregaDados()"
                      v-model="responsavel"
                      name="Responsável"
                      class="form-control form-control-sm"
                    >
                      <option value="">Todos</option>
                      <option v-for="usuario in usuarios"
                        :value="usuario.nome"
                        :key="usuario.nome">
                        {{usuario.nome}}
                      </option>
                    </select>
                  </div>

                  <div class="col-lg-4 form-group col-md-10">
                    <fa-icon icon="users" />
                    <label class="col-form-label col-form-label-sm font-weight-bold">Módulo:</label>
                    <select
                      name="Modulo"
                      v-model="modulo"
                      @change="carregaDados()"
                      class="form-control form-control-sm"
                    >
                      <option value selected>Todos</option>
                      <option
                        v-for="moduloOption in modulos"
                        :value="moduloOption.nome"
                        :key="moduloOption.nome"
                      > {{moduloOption.nome}} - {{moduloOption.idSistema == 1 ? "Service" : "Followair"}}</option>
                    </select>
                  </div>

                  <div class="col-lg-4 form-group col-md-10">
                    <fa-icon icon="users" />
                    <label class="col-form-label col-form-label-sm font-weight-bold">Classificação:</label>
                    <input
                      v-model="classificacao"
                      class="form-control form-control-sm"
                      name="Classificação"
                      placeholder="Informe a Classificação"
                    />
                  </div>

                  <div class="col-lg-4 form-group col-md-10">
                    <fa-icon icon="check" />
                    <label class="col-form-label col-form-label-sm font-weight-bold">Status:</label>
                    <select
                      v-model="status"
                      @change="carregaDados()"
                      name="Status"
                      class="form-control form-control-sm"
                    >
                      <option v-for="statusOption of statusOptions"
                        :key="statusOption.id"
                        :value="statusOption.id"
                        :selected="statusOption.id === status">
                          {{statusOption.value}}
                        </option>
                    </select>
                  </div>

                  <div class="col-lg-4 form-group col-md-10">
                    <fa-icon icon="pen-alt" />
                    <label class="col-form-label col-form-label-sm font-weight-bold">Projeto:</label>
                    <select
                      @change="carregaDados()"
                      name="Projeto"
                      v-model="projeto"
                      class="form-control form-control-sm"
                    >
                      <option value selected>Todos</option>
                      <option v-for="projetoOption in projetos" :value="projetoOption.id" :key="projetoOption.id">{{projetoOption.nome}}</option>
                    </select>
                  </div>

                  <div class="col-lg-4 form-group col-md-10">
                    <fa-icon icon="pen-alt" />
                    <label class="col-form-label col-form-label-sm font-weight-bold">Tipo do Ticket:</label>
                    <select
                      @change="carregaDados()"
                      name="TipoTicket"
                      v-model="tipoTicket"
                      class="form-control form-control-sm"
                    >
                      <option value selected>Todos</option>
                      <option
                        v-for="tipoTicketOption in tiposTicket"
                        :value="tipoTicketOption.id"
                        :key="tipoTicketOption.id"
                      >{{tipoTicketOption.nome}}</option>
                    </select>
                  </div>

                  <div class="col-lg-4 form-group col-md-10">
                    <fa-icon icon="clock" />
                    <label
                      class="col-form-label col-form-label-sm font-weight-bold"
                    >Data da Abertura Inicial:</label>

                    <input
                      v-model="inicio"
                      class="form-control form-control-sm"
                      v-validate="''"
                      style="display:none"
                      name="Inicio"
                      :class="{'is-invalid' : errors.has('Inicio')}"
                    />
                    <date-picker
                      ref="date"
                      :disabled="!_getPrivilegio(36)"
                      :clearable="true"
                      :input-class="'form-control form-control-sm ' + (errors.has('Inicio') ? 'is-invalid' : '' )"
                      v-model="inicio"
                      format="DD/MM/YYYY HH:mm"
                      type="datetime"
                      :minute-step="1"
                      :not-after="agora"
                      :confirm="true"
                      lang="pt-br"
                    ></date-picker>
                  </div>

                  <div class="col-lg-4 form-group col-md-10">
                    <fa-icon icon="clock" />
                    <label
                      class="col-form-label col-form-label-sm font-weight-bold"
                    >Data da Abertura Final:</label>
                    <input
                      v-model="fim"
                      class="form-control form-control-sm"
                      v-validate="''"
                      style="display:none"
                      name="Fim"
                      :class="{'is-invalid' : errors.has('Fim')}"
                    />
                    <date-picker
                      ref="date"
                      :disabled="!_getPrivilegio(36)"
                      :clearable="true"
                      :input-class="'form-control form-control-sm ' + (errors.has('Fim') ? 'is-invalid' : '' )"
                      v-model="fim"
                      format="DD/MM/YYYY HH:mm"
                      type="datetime"
                      :minute-step="1"
                      :not-after="agora"
                      :confirm="true"
                      lang="pt-br"
                    ></date-picker>
                  </div>

                  <div class="col-lg-4 col-md-10 form-group">
                    <label class="font-weight-bold" for="mostrarDesignados" > Visualização </label>

                    <div class="radio">
                      <label class="radio-inline">
                        <input id="mostrarDesignados" type="radio" v-model="mostrarDesignados" :value="false" @click="mudarVisualizacao" /> Lista
                      </label>&nbsp;&nbsp;&nbsp;
                      <label class="radio-inline">
                        <input id="mostrarDesignados" type="radio" v-model="mostrarDesignados" :value="true" @click="mudarVisualizacao" /> Cards
                      </label>
                    </div>
                      <!-- Ver como <b>{{mostrarDesignados ? 'lista' : 'cards'}}</b> -->
                  </div>
                </div>

                <div class="row" style="padding-left:10px;padding-right:10px">
                  <div class="col-lg-4 form-group col-md-10">
                    <fa-icon icon="pen-alt" />
                    <label class="col-form-label col-form-label-sm font-weight-bold">Ordenar por:</label>
                    <select
                      v-model="ordenar"
                      name="Ordem"
                      @change="carregaDados()"
                      class="form-control form-control-sm"
                    >
                      <option
                        v-for="opcaoOrdenacao in opcoesOrdenacao"
                        :value="opcaoOrdenacao.id"
                        :key="opcaoOrdenacao.id"
                        :selected="opcaoOrdenacao.id == ordenar">
                        {{ opcaoOrdenacao.value }}
                      </option>
                    </select>
                  </div>

                  <div class="col-lg-2 form-group col-md-10">
                    <fa-icon icon="pen-alt" />
                    <label class="col-form-label col-form-label-sm font-weight-bold">Classificação: </label>
                    <select
                      name="ClassificaçãoQuery"
                      v-model="classificacaoQuery"
                      @change="carregaDados()"
                      class="form-control form-control-sm"
                    >
                      <option
                        v-for="opcaoOrdenacaoAsc in opcoesOrdenacaoAsc"
                        :value="opcaoOrdenacaoAsc.id"
                        :key="opcaoOrdenacaoAsc.id"
                        :selected="opcaoOrdenacaoAsc.id == classificacaoQuery.toLowerCase()">
                        {{opcaoOrdenacaoAsc.value}}
                      </option>
                    </select>
                  </div>

                  <div class="col-lg-2 form-group col-md-10">
                    <fa-icon icon="pen-alt" />
                    <label class="col-form-label col-form-label-sm font-weight-bold">Por página: </label>
                    <select
                      name="perPage"
                      v-model="perPage"
                      @change="carregaDados()"
                      :disabled="perPage > 100 && mostrarDesignados"
                      class="form-control form-control-sm"
                    >
                      <option
                        v-for="perPagesOption of perPagesOptions"
                        :value="perPagesOption"
                        :key="perPagesOption"
                        :selected="perPagesOption === perPage">
                        {{ perPagesOption > 100 ? 'Todos' : perPagesOption }}
                      </option>
                    </select>
                  </div>

                  <div class="col-lg-4 col-md-10" :class="{'col-md-offset-2 col-lg-offset-2': mostrarDesignados}">
                    <button
                      class="btn btn-success btn-sm float-right"
                      @click="() => $refs.table.reseta()"
                    >
                      <fa-icon icon="search" transform="left-3" />FILTRAR
                    </button>
                  </div>
                </div>

                <div id="esconde-filtros" class="muda-filtro" @click="alterarFiltros(true)">
                  <h4>
                    <fa-icon icon="search" /> Ocultar Filtros
                  </h4>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <flCarregando style="margin-top:20px" v-if="load" />

      <fl-table-server-side
        v-show="!load && !mostrarDesignados"
        ref="table"
        :perPage="perPage"
        @click-detalhe="clickEditar"
        @carrega-dados="carregaDados"
        class="animated fadeIn fast"
        columnStartSortable="status"
        :columns="geraCabecalhos()"
      />

      <fl-board-designado
        v-show="!load"
        v-if="usuarios && tickets && mostrarDesignados"
        :responsaveis="usuarios"
        :tickets="tickets"
        @click-editar="clickEditar"
      />
    </div>

    <div v-if="exibeForm" class="animated fadeIn faster">
      <flCadastro @fechar="exibeForm = false" ref="cadastro" @item-salvo="atualizaItem" />
    </div>
  </div>
</template>

<script>
import _ from 'lodash'
import flCadastro from './cadastro.vue'
import flCarregando from '../../../components/carregando/main.vue'
import moment from 'moment'
import flTableServerSide from '../../../components/table-server-side/main.vue'
import axios from '../../../routers/axios'
import flFind from '../../../components/find/main.vue'
import { mapState } from 'vuex'
import Designado from './designado.vue'

export default {
  components: {
    flCadastro,
    flCarregando,
    flTableServerSide,
    flFind,
    'fl-board-designado': Designado
  },

  data() {
    return {
      modulos: [],
      projetos: [],
      tiposTicket: [],
      agora: moment(),
      load: true,
      exibeForm: false,
      exibirFiltro: false,
      exibirConcluidas: false,
      exibirCanceladas: false,
      codigo: '',
      cliente: '',
      prioridade: '',
      responsavel: '',
      modulo: '',
      status: '',
      projeto: '',
      tipoTicket: '',
      inicio: '',
      fim: '',
      ordenar: 'status',
      classificacao: '',
      classificacaoQuery: 'desc',
      perPage: 10,
      campoBusca: 'codigo',
      busca: '',
      columnsBusca: [
        { title: 'Código', key: 'codigo' },
        { title: 'Cliente', key: 'cliente.nome' },
        { title: 'Prioridade', key: 'prioridade' },
        { title: 'Responsável', key: 'usuario.nome' },
      ],
      opcoesOrdenacao: [
        {id: '', value: 'Selecione uma ordenação'},
        {id: 'codigo', value: 'Código'},
        {id: 'cliente.nome', value: 'Cliente'},
        {id: 'prioridade', value: 'Prioridade'},
        {id: 'usuario.nome', value: 'Responsável'},
        {id: 'status', value: 'Status'},
        {id: 'projeto.nome', value: 'Projeto'},
        {id: 'data_abertura', value: 'Data da Abertura'},
      ],
      opcoesOrdenacaoAsc: [
        {id: 'asc', value: 'Ascendente'},
        {id: 'desc', value: 'Descendente'},
      ],
      perPagesOptions: [10,20,50,100, 10000],
      clientesOptions: [],
      prioridadesOptions: [
        {id: 'ALTA', value: 'Alta'},
        {id: 'MEDIA', value: 'Média'},
        {id: 'BAIXA', value: 'Baixa'}
      ],
      statusOptions: [
        {id: '', value: 'Todos'},
        {id: 'A', value: 'Aberto'},
        {id: 'E', value: 'Em Execução'},
        {id: 'O', value: 'Conluído'},
        {id: 'C', value: 'Cancelado'},
      ],
      usuarios: [],
      tickets: [],
      mostrarDesignados: false,
      momentFormat: 'DD/MM/YYYY HH:mm',
    };
  },

  created() {
    this.getClientes()
    this.getModulos()
    this.getProjetos()
    this.getTiposTicket()
    this.getUsuarios()
  },

  computed: {
    ...mapState({
      config: state => state.sessao.config
    }),
  },

  methods: {
    alterarFiltros(exibir) {
      this.exibirFiltro = exibir;
    },
    atualizaItem(item) {
      this.exibeCadastro = false;
      this.$notify.show('success', 'Ticket salvo.');
      // this.$refs.table.atualizaItem(this.geraColunas(item))
    },

    clickEditar(item) {
      this.exibeForm = true;
      window.scrollTo(0, 0);

      this.$nextTick(() => {
        this.$refs.cadastro.editar(item._object);
      });
    },
    clickCadastrar() {
      this.exibeForm = true;
      window.scrollTo(0, 0);
    },
    setarOrdenacaoPorCabecalho(columnOrder, order) {
      this.ordenar = columnOrder || this.ordenar
      this.classificacaoQuery = order || this.classificacaoQuery
    },
    carregaDados(columnOrder, order, perPage, start = 0) {
      this.load = true
      this.setarOrdenacaoPorCabecalho(columnOrder, order)
      let url = `api/ticket?codigo=${this.codigo}&cliente=${this.cliente}`
      url += `&prioridade=${this.prioridade}&responsavel=${this.responsavel}`
      url += `&status=${this.status}&modulo=${this.modulo}&projeto=${this.projeto}`
      url += `&tipoTicket=${this.tipoTicket}&inicio=${moment(this.inicio).format("YYYY/MM/DD H:mm:ss")}`
      url += `&fim=${moment(this.fim).format("YYYY/MM/DD H:mm:ss")}&ordenar=${this.ordenar}`
      url += `&classificacao=${this.classificacao}&classificacaoQuery=${this.classificacaoQuery}`
      url += `&qtd=${this.perPage}&start=${start}`
      url = this._getUrl(url)
      // `api/ticket/${this.exibirCanceladas}/${this.exibirConcluidas}/${columnOrder}/${order}/${perPage}/${start}`

      if (this.busca.trim().length) {
        url += `/${this.busca}/${this.campoBusca}`
      }

      axios.get(url).then(response => {
        this.load = false
        response.data.list = response.data.list.map((item) => {
          item.vencido = false
          item._dataAbertura = new moment.utc(item.dataAbertura).local().format(this.momentFormat)

          item._dataPrevisao = null
          if (item.dataPrevisao) {
            item._dataPrevisao = new moment.utc(item.dataPrevisao).local().format(this.momentFormat)
            const previsao = new moment.utc(item.dataPrevisao)
            if (moment.utc().isAfter(previsao)) {
              item.vencido = true
            }
          }

          item._dataEncerramento = null
          if (item.dataEncerramento) {
            item._dataEncerramento = new moment.utc(item.dataEncerramento).local().format(this.momentFormat)
          }
          return this.geraColunas(item)
        })
        this.tickets = response.data.list.map((ticket) => ticket._object)
        this.$refs.table.loadTable(response.data.list, response.data.qtd)
      });
    },

    geraColunas(item) {
      let itemLista = {};
      let columns = [];

      let status = ''
      let devConcluido = ''
      let textColor = ''

      if (item.status == 'A') {
        status = 'Aberto'
        textColor = 'text-primary'
      }

      if (item.status == 'C') {
        status = 'Cancelado'
        textColor = 'text-danger'
      }

      if (item.status == 'O') {
        status = 'Concluído'
        textColor = 'text-success'
      }

      if (item.status == 'E') {
        status = 'Em Andamento'
        textColor = 'text-info'
      }

      if (item.desenvolvimentoConcluido) {
        devConcluido = `<div class="text-secondary">
									<small>
										(Dev Concluído)
									</small>
								</div>`
      }

      columns.push({
        html: `<strong>${status}</strong>${devConcluido}`,
        class: textColor
      })
      columns.push({
        html: `${item.codigo}<br/><small>${item.nomeCliente}</small>`
      })
      columns.push({ html: item._dataAbertura })
      columns.push({ html: item.titulo })
      columns.push({ html: item.nomeResponsavel })
      columns.push({ html: item.prioridade })
      columns.push({ html: item._dataPrevisao })

      columns.push({
        class: 'text-center',
        clickable: true,
        event: 'click-detalhe',
        icon: ['far', 'arrow-alt-circle-right'],
        style: 'font-size: 1.8em'
      })

      itemLista._object = item
      itemLista.columns = columns
      return itemLista;
    },

    geraCabecalhos() {
      const columns = []

      columns.push({
        name: 'Status',
        key: 'status',
        keyOrder: 'status',
        sortable: true,
        width: '5%',
        value: 'STA',
      })

      columns.push({
        name: 'Código',
        key: 'codigo',
        sortable: true,
        width: '8%',
        value: 'COD',
      })

      columns.push({
        name: 'Abertura',
        key: 'data_abertura',
        sortable: true,
        width: '8%',
        value: 'DAT',
      })

      columns.push({
        name: 'Título',
        key: 'titulo',
        sortable: false,
        width: '12%'
      })

      columns.push({
        name: 'Responsável',
        key: 'usuario.nome',
        sortable: true,
        width: '8%',
        value: 'RES',
      })

      columns.push({
        name: 'Prioridade',
        key: 'prioridade',
        sortable: true,
        width: '5%',
        value: 'PRI'
      })

      columns.push({
        name: 'Previsão',
        key: 'data_previsao',
        sortable: false,
        width: '10%'
      })

      columns.push({
        name: 'Datalhes',
        key: 'detalhes',
        sortable: false,
        class: '',
        width: '3%'
      })

      return columns
    },
    getClientes() {
      axios.get(this._getUrl('api/cliente')).then(response => {
        if (response.status == 200) {
          this.clientesOptions = response.data
        }
      })
    },
    getModulos() {
      axios.get(this._getUrl('api/modulo')).then(response => {
      if (response.status == 200) {
        this.modulos = response.data;
        }
      })
    },
    getProjetos() {
      axios.get(this._getUrl('api/projeto')).then(response => {
      if (response.status == 200) {
          this.projetos = response.data;
        }
      })
    },
    getTiposTicket() {
      axios.get(this._getUrl('api/tipoTicket')).then(response => {
        if (response.status == 200) {
          this.tiposTicket = response.data;
        }
      })
    },
    getUsuarios() {
      axios.get(this._getUrl('api/login')).then(result => {
        if (result.status == 200) {
          this.usuarios = result.data.filter((usuario) => {
            return usuario.perfis.some((perfil) => {
              return perfil.id == this.config.idPerfilDesenvolvedor
            })
          })
        }
      })
    },

    mudarVisualizacao() {
      this.perPage = (!this.mostrarDesignados) ? 10000 : 10
      this.carregaDados()
      // console.log({route: this.mostrarDesignados})
      // if (this.$route) {
        // this.mostrarDesignados = this.$route.query.visualizacao == 'designado'
      // } else {
      //   this.perPage = 10
      // }
    }

  }
};
</script>

<style>
.scrolling-wrapper {
  overflow-x: scroll;
  overflow-y: hidden;
  white-space: nowrap;
}

.card-block {
  min-height: 220px;
}

.block-flat,
.block-wizard {
  margin-bottom: 40px;
  padding: 20px 20px;
  background: #fff;
  border-radius: 3px;
  position: relative;
  -webkit-border-radius: 3px;
  border-left: 1px solid #efefef;
  border-right: 1px solid #efefef;
  border-bottom: 1px solid #e2e2e2;
  box-shadow: 0 1px 0 0 rgba(0, 0, 0, 0.04);
  transition: padding 500ms;
  -moz-transition: padding 500ms;
  -webkit-transition: padding 500ms;
}
.muda-filtro h4 {
  margin: 0px;
  padding: 15px;
  text-align: center;
  color: #fff;
  background: #3c94e0;
  cursor: pointer
}
h1,
h2,
h3,
h4,
h5,
h6,
.h1,
.h2,
.h3,
.h4,
.h5,
.h6 {
  font-family: "Open Sans", sans-serif;
  font-weight: 300;
}
h4,
.h4 {
  font-size: 1.275rem;
}
h1,
h2,
h3,
h4,
h5,
h6,
.h1,
.h2,
.h3,
.h4,
.h5,
.h6 {
  font-family: inherit;
  font-weight: 500;
  line-height: 1.1;
  color: inherit;
}
</style> 



// WEBPACK FOOTER //
// src/views/ticket/geral/main.vue